import React from 'react';

import { AuthProvider } from './Auth';
import { ToastProvider } from './Toast';
import ValidateTokenProvider from './ValidateTokenProvider';

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <ToastProvider>
      {children}
      <ValidateTokenProvider />
    </ToastProvider>
  </AuthProvider>
);

export default AppProvider;
